import { render, staticRenderFns } from "./brand-footer.vue?vue&type=template&id=b04defa0&scoped=true"
import script from "./brand-footer.vue?vue&type=script&lang=js"
export * from "./brand-footer.vue?vue&type=script&lang=js"
import style0 from "./brand-footer.vue?vue&type=style&index=0&id=b04defa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04defa0",
  null
  
)

export default component.exports